<template>
  <div>
    <v-card class="my-3" style="position: relative">
      <v-tooltip v-if="!item.pinned" top>
        <v-btn
          color="secondary"
          dark
          absolute
          slot="activator"
          small
          @click="allowPin = true"
          style="left: -11px;top: -11px;z-index: 1;width: 30px;height: 30px;"
          fab
        >
          <v-icon style="display:flex" small>fa-thumb-tack</v-icon>
        </v-btn>
        <span>Pin post</span>
      </v-tooltip>
      <v-tooltip v-else-if="item.pinned" top>
        <v-btn
          color="red"
          dark
          absolute
          slot="activator"
          small
          @click="removePin()"
          style="left: -11px;top: -11px;z-index: 1;width: 30px;height: 30px;"
          fab
        >
          <v-icon style="display:flex" small>fa-thumb-tack</v-icon>
        </v-btn>
        <span>Unpin post</span>
      </v-tooltip>
      <v-list two-line dense class="">
        <v-list-tile avatar>
          <v-menu max-width="300" min-width="250" z-index="1" bottom :nudge-bottom="30" :nudge-top="-20" :nudge-left="10">
            <v-list-tile-avatar slot="activator">
              <img alt="User avatar" :src="item && item.user && item.user.avatar ? item.user.avatar : require('@/assets/images/default-avatar.gif')">
            </v-list-tile-avatar>
            <avatar-popup :item="item" :uid="item.uid" />
          </v-menu>
          <v-list-tile-content>
            <v-list-tile-title :style="{color: styles.general.theme_color_dark}" style="font-size:15px;font-weight:900;text-transform:capitalize;">{{ item.user.firstname + ' ' + item.user.lastname}}</v-list-tile-title>
            <v-list-tile-sub-title ><div style="color:#000;font-size:15px;">{{ item.user.jobtitle }} <span v-if="item.user.jobtitle && item.company">| {{ item.company.companylegalname }}</span></div></v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action>
              <v-icon class="secondary--text" style="cursor:pointer" v-if="likes.includes(getUserDetails.uid)" @click.prevent="unLikePost(item, itemKey)">fa-thumbs-up</v-icon>
              <v-icon style="cursor: pointer" v-else @click.prevent="likePost(item, itemKey)">fa-thumbs-o-up</v-icon>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
      <v-layout class="px-3 mb-3">
        <span style="white-space: pre-wrap;" v-if="!item.type">{{item.content}}</span>
        <div style="white-space: pre-wrap;" v-if="item.type && item.type === 'rss'">
          <b>{{ item.title }}</b>
          <div class="mt-1">{{ item.content }}</div>
          <div class="mt-1" v-if="item.link">
            <a rel="noopener" :href="timelineLink(item.link)" target="_blank">Link to article</a>
          </div>
          <div class="mt-1">{{itemRssFeedCategories.join(' ')}}</div>
        </div>
      </v-layout>
      <v-layout row wrap>
        <v-flex v-if="item.video" :class="{ 'xs12': true, 'md6': item.video && item.attachmentUrl, 'md12': item.video && !item.attachmentUrl}">
          <iframe allowfullscreen style="width: 100%; height: 260px;border:0px" :src="item.video.embedUrl"></iframe>
        </v-flex>
        <v-flex v-if="item.attachmentUrl" :class="{ 'xs12': true, 'md6': item.attachmentUrl && item.video, 'md12': item.attachmentUrl && !item.video  }" class="text-xs-center">
          <div class="rss-feed-image" v-if="item.type && item.type === 'rss'" :style="{ backgroundImage: `url(${item.attachmentUrl.replace('http:', 'https:')})` }"></div>
          <img alt="Post Image" v-if="!item.type" :src="item.attachmentUrl.replace('http:', 'https:')" style="width: 100%; height: auto;" class="py-2"/>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex md12 style="font-size: 13px;">
          <v-subheader class="pl-0"><span class="pl-3" style="font-weight: 900;" :style="{color: styles.general.theme_color_dark}"><a :style="{color: styles.general.theme_color_dark}"  style="cursor: pointer;font-weight:900;font-size:15px;" @click.prevent="toggleComments">Comments ({{ comments.length || 0 }})</a> <span>·</span> Likes ({{ likes.length }})</span></v-subheader>
          <v-divider class="mt-0 px-2"></v-divider>
        </v-flex>
      </v-layout>
      <v-list three-line dense style="" :class="{ 'hidden': !showComments }" v-if="comments.length > 0">
        <v-list-tile avatar v-for="(comment) in comments" v-bind:key="comment.commentId">
          <v-menu max-width="300" min-width="250" z-index="1" bottom :nudge-bottom="30" :nudge-top="-20" :nudge-left="10">
            <v-list-tile-avatar slot="activator">
              <img :alt="comment && comment.user.avatar ? comment.user.avatar : 'default-avatar.gif'" :src="comment && comment.user.avatar ? comment.user.avatar : require('@/assets/images/default-avatar.gif')">
            </v-list-tile-avatar>
            <avatar-popup :item="comment" :uid="comment.user.uid" />
          </v-menu>
          <v-list-tile-content>
            <v-list-tile-title :style="{color: styles.general.theme_color_dark}" style="font-size:15px;font-weight:900;text-transform:capitalize;margin-top: -17px;">{{ comment.user.firstname + ' ' + comment.user.lastname}}</v-list-tile-title>
            <v-list-tile-sub-title>{{ comment.comment }}</v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action>
             <span>{{ comment.date | fromNow }}</span>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
      <v-divider :class="{ 'hidden': !showComments }" v-if="comments.length > 0"></v-divider>
      <v-layout row wrap>
        <v-flex md9 xs12 sm12>
          <v-text-field class="mt-0" full-width single-line label="Leave a comment" v-model="comment" style="padding-bottom: 0px;height:100%">
          </v-text-field>
        </v-flex>
        <v-flex md3 xs12 sm12>
          <div class="text-xs-center pt-2" style="float: right">
            <v-btn @click.prevent="postComment(itemKey)" round :style="{color: styles.general.theme_color_dark}" flat style="font-weight:900;font-size:22px;" dark>Post</v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-card>
    <v-dialog v-model="allowPin" max-width="490">
      <v-card>
        <v-card-title class="headline">Pin this Post to the top of the activity feed</v-card-title>
        <v-card-text>This will replace any previously pinned post. Are you sure?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat="" @click.native="allowPin = false">No</v-btn>
          <v-btn color="secondary" @click.native="pinPost();allowPin=false">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import AvatarPopup from '@/components/ui/AvatarPopup'
  import { mapGetters } from 'vuex'
  import 'mdi/css/materialdesignicons.min.css'
  import Vue from 'vue'

  let db = Vue.prototype.$firebase.database()

  export default {
    props: ['item', 'itemKey', 'type', 'extraUrl'],
    components: {
      AvatarPopup
    },
    data () {
      return {
        anArray: {},
        comment: '',
        showComments: false,
        allowPin: false,
        count: 0,
        items: [],
        feed: [],
        user: this.getUserDetails,
        companyInformation: {},
        divcount: 0,
        comments: []
      }
    },
    firebase() {
      return {
        fetchLikes: db.ref(`${this.type}${this.extraUrl}/${this.itemKey}`).child('likes'),
        getComments: db.ref(`${this.type}${this.extraUrl}/${this.itemKey}`).child('comments')
      }
    },
    mounted() {
      this.getUserComments
    },
    computed: {
      ...mapGetters([
        'getUserDetails'
      ]),
      styles () {
        return this.$store.getters.getStyles
      },
      isAdmin() {
        if (this.$store.getters.getUserDetails.role === 1) {
          return true
        }
        return false
      },
      itemRssFeedCategories () {
        var categories = []
        if (this.item.type && this.item.type === 'rss') {
          categories = this.item.categories.map(category => {
            return `#${category.replace(' ', '-')}`.toLowerCase()
          })
          return categories
        }
      },
      likes() {
        const values = []
        this.fetchLikes.forEach((item, index) => {
          values.push(item['.value'])
        })
        return values
      },
      getUserComments() {
        const self = this
        return this.$firebaseRefs.getComments.on('value', function(result) {
          if (result.val()) {
            const commentKeys = Object.keys(result.val())
            const userIds = self._.uniq(commentKeys.map((comment) => result.val()[comment].uid))
  
            const userInfo = userIds.map(id => {
              return self.$firebase.database().ref('users/' + id).once('value')
            })
  
            Promise.all(userInfo)
              .then((users) => {
                self.comments = []
                users.forEach((user) => {
                  commentKeys.forEach((comment) => {
                    if (result.val()[comment].uid === user.val().uid) {
                      let item = result.val()[comment]
                      item.commetId = comment
                      item.user = {}
                      Object.assign(item.user, user.val())
                      self.comments.push(item)
                    }
                  })
                })
              })
          } else {
            self.comments = []
          }
        })
      }
    },
    methods: {
      pinPost () {
        const self = this
        const pinnedItem = this.item.postKey
        this.$firebase.database().ref('pinnedPost').once('value', (snapshot) => {
          const postId = snapshot.val()
          if (postId) {
            return self.$firebase.database().ref(`posts/${pinnedItem}/pinned`).set(true).then(() => {
              return self.$firebase.database().ref('pinnedPost').set(pinnedItem).then(() => {
                setTimeout(() => {
                  return self.$firebase.database().ref(`posts/${postId}/pinned`).set(null)
                }, 3000)
              })
            })
          }
          return self.$firebase.database().ref(`posts/${pinnedItem}/pinned`).set(true).then(() => {
            return self.$firebase.database().ref('pinnedPost').set(pinnedItem)
          })
        })
      },
      removePin () {
        const self = this
        this.$firebase.database().ref('pinnedPost').once('value', (snapshot) => {
          const postId = snapshot.val()
          return self.$firebase.database().ref(`posts/${postId}/pinned`).set(null).then(() => {
            return self.$firebase.database().ref('pinnedPost').set(null)
          })
        })
      },
      timelineLink (link) {
        return encodeURI(`${window.location.protocol}//${window.location.host}/r/?to=${link}`)
      },
      likePost (item, key) {
        this.$firebase.database().ref(`${this.type}${this.extraUrl}/${item.postKey}/likes/${this.getUserDetails.uid}`).set(this.getUserDetails.uid)
      },
      unLikePost (item, key) {
        this.$firebase.database().ref(`${this.type}${this.extraUrl}/${item.postKey}/likes/${this.getUserDetails.uid}`).remove()
      },
      postComment (postKey) {
        if (this.comment === '') {
          let snackbar = {
            active: true,
            text: 'Please enter something'
          }
          this.$store.dispatch('triggerSnackbar', snackbar)
          return null
        }
        var self = this
        const comment = {
          uid: this.getUserDetails.uid,
          comment: this.comment,
          date: Date.now()
        }
        this.$firebase.database().ref(`${this.type}${this.extraUrl}/${postKey}/comments`).push(comment)
        this.comment = ''
      },
      toggleComments () {
        if (this.showComments) {
          this.showComments = false
          return false
        }
        this.showComments = true
        return true
      },
    }
  }

</script>
<style>
  .background-image {
    background-position-y: center;
    background-size: cover;
    background-repeat: no-repeat;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    bottom: 0;
  }

  .icon-red i {
    color: #ff1b00 !important;
  }

  .icon-blue i {
    color: #0388d1 !important;
  }

  .com-like {
    background: rgb(66, 66, 66);
    color: #fff;
    padding-top: 6px;
    border-radius: 0px 20px 20px 0px;
    padding-right: 17px;
    padding-bottom: 6px;
  }
  .hidden {
    display: none;
  }
  .rss-feed-image {
    width: 100%;
    height: 200px;
    background-position:center;
  }
</style>





// WEBPACK FOOTER //
// Timeline.vue?11bf7490